// Libraries
import React from "react";
import { connect } from 'react-redux';

// Local Libraries
import { gisRoutes } from "../../../routes/routes";
import { supportedLanguages } from "../../../i18n/supported-languages";
import phrasebookLoad from "../../../i18n";
import * as token from '../../../helpers/token';
import { accountTypesConstants } from '../../../constants';
import { capitalizeFirstLetter } from "../../../helpers/util"

// Redux
import { configActions } from 'actions';

// Components
import { NewBreadcrumbs } from "../../../components/SkyFramework/Breadcrumbs/NewBreadcrumbs";
import { SubmitButton, CancelButton } from "../../../components/SkyFramework/Buttons";
import { Form } from "../../../components/SkyFramework/Forms";

// Constants
const phrasebook = phrasebookLoad()

class ConfigurationEdit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      configuration: undefined,
      submitted: false
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.account_type_logged = accountTypesConstants[token.loggedAccountType()];

  }

  componentDidMount() {


    this.props.dispatch(configActions.getAll());

  }

  componentDidUpdate(prevProps) {
    if (this.props.configuration && prevProps && prevProps.configuration !== this.props.configuration) {
      this.props.configuration.data.map(field => {
        this.setState({ [field.field]: field.value });
      })
      this.setState({ configuration: this.props.configuration.data });
    }
  }

  handleChange(e) {
    const { id, name, value, checked, type } = e.target;
    if (type === 'checkbox' && checked !== undefined) {
      this.setState({ [id]: checked });
    }
    else if (id) this.setState({ [id]: value });
    else if (name) this.setState({ [name]: value });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ submitted: true });
    var updatedValues = {};
    this.state.configuration.map(field => {
      updatedValues[field.field] = this.state[field.field];
    })

    this.props.dispatch(configActions.update(updatedValues))
  }

  FormConfiguration = () => {
    if (this.state.configuration) {

      var inputs = [];

      this.state.configuration.map(field => {
        if (field.type == "string") inputs.push({ label: field.field, type: "text", placeholder: field.field, id: field.field, name: field.field, value: this.state[field.field] })
        else if (field.type == "password") inputs.push({ label: field.field, type: "password", placeholder: field.field, id: field.field, name: field.field, value: this.state[field.field] })
        else if (field.type == "boolean") inputs.push({ label: field.field, type: "checkbox", placeholder: field.field, id: field.field, name: field.field, value: this.state[field.field] ? true : false })
      })

      const buttons = [<CancelButton title={phrasebook.common.back} link={gisRoutes.dashboard[this.account_type_logged]} />, <SubmitButton title={phrasebook.common.update} />]
      return (
        <Form
          handleSubmit={this.handleSubmit}
          onChange={this.handleChange}
          title={`${phrasebook.common.update} ${phrasebook.headerlinks.configuration}`}
          inputs={inputs}
          buttons={buttons}
        />)
    } else return null;
  }

  render() {
    return <>
      <NewBreadcrumbs crumbs={[{ link: gisRoutes.dashboard[this.account_type_logged], label: phrasebook.common.home }, { link: gisRoutes.administration.configuration.edit, label: phrasebook.headerlinks.configuration }]} current={`${phrasebook.common.edit} ${phrasebook.headerlinks.configuration}`} />

      {this.FormConfiguration()}
    </>
  }
}

function mapStateToProps(state) {
  const { loggedpermissions, config, authentication } = state;
  const { authUser } = authentication;
  return {
    authUser,
    loggedpermissions,
    configuration: config.config,

  };
}


const configEdit = connect(mapStateToProps)(ConfigurationEdit);
export default (configEdit);
